var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmenitiesIconsBikeParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#666adc",
    r: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.7277 14.1373-1.4236-4.30955c-.0931-.28192-.3565-.47228-.6534-.47228h-1.5858c-.38 0-.6881.30807-.6881.68813 0 .3801.3081.6882.6881.6882h1.0884l.3694 1.1182h-6.8605l-.1036-.172h.1732c.38 0 .6881-.3081.6881-.6882s-.3081-.6881-.6881-.6881h-2.1505c-.38 0-.68811.308-.68811.6881s.30811.6882.68811.6882h.371l.5361.8906-.7697 1.6865c-1.43921-.3915-3.01201-.0103-4.12909 1.1068-1.67448 1.6745-1.67516 4.3521 0 6.0273 2.46834 2.4684 6.66199 1.0848 7.22499-2.3137h1.9733c.2118 0 .4117-.0975.5422-.2643l3.8606-4.9391.2293.6942c-1.3724.7136-2.312 2.1488-2.312 3.7996 0 2.3597 1.9197 4.2794 4.2794 4.2794s4.2794-1.9197 4.2794-4.2794c0-2.6071-2.3316-4.6339-4.9391-4.2286zm-9.3789-.1392 2.2277 3.7011h-.7582c-.1937-1.2076-.8955-2.229-1.8484-2.8709zm-.9602 2.104c.5033.3961.8722.9551 1.0267 1.5971h-1.7556zm-1.78533 5.1662c-1.59504 0-2.89272-1.2977-2.89272-2.8927 0-1.7981 1.63642-3.1772 3.42505-2.8428l-1.1724 2.5688c-.20786.4556.12589.9739.62604.9739h2.82066c-.3139 1.2579-1.453 2.1928-2.80663 2.1928zm6.26183-4.0972-2.3745-3.9448h5.458zm6.5223 4.0979c-1.6008 0-2.9032-1.3023-2.9032-2.9031 0-1.0408.5508-1.9549 1.3759-2.4675l.8843 2.677c.0955.2893.3645.4725.6532.4725.4682 0 .8007-.4589.6536-.9041l-.8827-2.672c1.6964-.1271 3.1219 1.2188 3.1219 2.8941.0001 1.6008-1.3022 2.9031-2.903 2.9031z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmenitiesIconsBikeParking);
export default __webpack_public_path__ + "static/media/AmenitiesIconsBikeParking.dddcb193ecb7b2c8b253785af8b19cd8.svg";
export { ForwardRef as ReactComponent };